<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
          <SideMenu />
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-6 py-5 pl-sm-14 mt-10">
          <div class="organization-payments dashboard py-0">
            <v-row justify="center">
              <v-col cols="12" sm="12" md="11" lg="10">
                <!-- Blue Banner -->
                <v-card
                  class="rounded-lg back-color py-0 d-block d-md-flex align-center justify-center"
                  elevation="0"
                >
                  <v-card-title class="text-h4 d-block text-center">
                    <span class="ats-title blue--text text--light-blue text--darken-4 pr-1">¡Hola</span>
                    <span class="ats-title white--text">{{ `${getRole !== 'sysadmin' ? getUser.organization.name : getUser.firstName}!` }}</span>
                  </v-card-title>
                </v-card>

                <v-row class="py-10">
                  <!-- Resumen -->
                  <v-col cols="12" md="6">
                    <v-card
                      class="organization-payments__summary"
                      elevation="0"
                    >
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-card class="summary-card">
                              <h4 class="summary-card__title">Ofertas publicadas</h4>
                              <p class="summary-card__data">{{ summary.published }}</p>
                            </v-card>
                          </v-col>

                          <v-col cols="6">
                            <v-card class="summary-card">
                              <h4 class="summary-card__title">Ofertas disponibles</h4>
                              <p class="summary-card__data">{{ summary.available }}</p>
                            </v-card>
                          </v-col>

                          <v-col cols="6">
                            <v-card class="summary-card">
                              <h4 class="summary-card__title">Ofertas compradas</h4>
                              <p class="summary-card__data">{{ summary.purchased }}</p>
                            </v-card>
                          </v-col>

                          <v-col cols="6">
                            <v-card class="summary-card">
                              <h4 class="summary-card__title">Fecha de vencimiento</h4>
                              <p class="summary-card__data summary-card__data--date">{{ summary.expiration }}</p>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>

                  <!-- Tarjetas compras [XS, SM] -->
                  <v-col
                    class="d-block d-md-none"
                    cols="12"
                  >
                    <h3 class="organization-payments__title">Mis Compras</h3>
                    <v-row>
                      <v-col
                        v-for="(payment, index) in payments"
                        :key="index"
                        cols="12"
                      >
                        <v-card class="purchase-card">
                          <div>
                            <h3 class="purchase-card__title">{{ payment.description }}</h3>
                            <p class="purchase-card__text">Fecha compra</p>
                            <p class="purchase-card__text">{{ payment.createdAt }}</p>
                          </div>
                          <v-btn
                            class="purchase-card__btn"
                            :disabled="!payment.document"
                            @click="getInvoice(payment.document)"
                          >
                            DESCARGAR FACTURA
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Tabla compras [MD+] -->
                  <v-col class="d-none d-md-block" cols="12" md="6">
                    <h3 class="organization-payments__title">Mis Compras</h3>
                    <v-data-table 
                      class="purchase-table"
                      height="100%" 
                      :headers="headers" 
                      :items="payments" 
                      :loading="loading" 
                      loading-text="Cargando pagos... Por favor espere"
                      fixed-header
                      hide-default-header
                      hide-default-footer
                      disable-pagination
                    >
                      <template #header="{props: { headers }}">
                        <thead>
                          <tr>
                            <th
                              v-for="header in headers"
                              :key="header.value"
                              class="purchase-table__header"
                            >
                              {{ header.text }}
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <!-- Description -->
                      <template v-slot:[`item.description`]="{ item }">
                        <span class="purchase-table__description">{{ item.description }}</span>
                      </template>
                      
                      <!-- Date -->
                      <template v-slot:[`item.createdAt`]="{ item }">
                        <span class="purchase-table__date">{{ item.createdAt }}</span>
                      </template>

                      <!-- Download -->
                      <template v-slot:[`item.document`]="{ item }">
                        <v-btn 
                          class="purchase-table__btn ma-0 d-block btn-form"
                          :disabled="!item.document"
                          color="info"
                          @click="getInvoice(item.document)"
                          block
                          text
                        >
                          DESCARGA
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import SideMenu from "@/components/SideMenu";
import { datetime, meta } from "@/libs/mixins";
import { packs, packsDesc } from "@/config/fixtures";

export default {
    name: "OrganizationPayments",

    components: {
        SideMenu
    },

    props: ["users"],

    mixins: [datetime, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: `Compras de ${ this.getUser.organization.name }`,
        });
    }, 

    data() {
        return {
            loading: false,
            dashboard: {},
            headers: [
                {
                    text: "Descripción",
                    align: "left",
                    sortable: false,
                    value: "description",
                },
                {
                    text: "Fecha compra",
                    value: "createdAt",
                    align: "center",
                },
                {
                    text: "Invoice / Factura",
                    value: "document",
                    align: "center",
                }
            ],
            payments: [
            ],
            errors: []
        };
    },

    created() {
        this.loading = true;
        this.$store.dispatch("accounts/getPayments", {}).then((result) => {
          
            let names = {};
            packsDesc.forEach((pack, idx) => {
                names[packs[idx].packCode] = pack.name;
            });

            this.loading = false;
            let payments = result.payments;
            this.dashboard = result.resume;
            console.log(this.dashboard);

            if (this.dashboard.createdAt && !this.dashboard.expiredAt) {
                this.dashboard.expiredAt = new Date(this.dashboard.createdAt);
                this.dashboard.expiredAt.setFullYear(this.dashboard.expiredAt.getFullYear() + 1);
            }
            
            payments = payments.sort(function(a, b) {
                return new Date(b.expiredAt) - new Date(a.expiredAt);
            });
            
            payments.forEach((payment) => {
                let expiredAt = new Date(payment.createdAt);
                expiredAt.setFullYear(expiredAt.getFullYear() + 1);
                this.payments.push({
                    ...payment,
                    description: names[payment.bucketCode],
                    createdAt: this.formatterDate(payment.createdAt, "ddmmyy"),
                    expiredAt: this.formatterDate(expiredAt, "ddmmyy")
                });
            });
        }).catch((err) => {
            console.error(err);
            this.loading = false;
        });
    },

    computed: {
        ...userComputed,

        summary() {
            return {
                available: this.dashboard.availables || "-",
                expiration: this.dashboard.expiredAt ? this.formatterDate(this.dashboard.expiredAt, "ddmmyy") : "-",
                published: this.dashboard.published || "-",
                purchased: this.dashboard.purchased || "-",
            };
        }
    },

    methods: {
        getInvoice(filename) {
            let url = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_INVOICE_PATH + filename;
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = encodeURI(url);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },
    }  
};
</script>

<style scoped>
    .v-data-table >>> tbody tr:nth-of-type(odd) {
        background-color:#DDF1FF;
    }
    .v-data-table >>> tr:first-child td {
        border-top: 1px solid #3BADFF;
    }
    .v-data-table >>> td {
        border-bottom: 1px solid #3BADFF;
        font-family: "Circular" !important;
    }
</style>
